import React, { Component } from 'react';
import { Info, CheckCircle2, Wrench, Package } from 'lucide-react';
const partsList = ['Impellers', 'Pump Seals', 'Pump Housings', 'Mounting Brackets', 'Repair Kits', 'Replacement Motors & Components'];
export function RepairKits() {
  return <section className="w-full bg-white" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-110">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-111">
          {/* Intro + parts */}
          <div data-id="element-112">
            <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-3" data-id="element-113">
              Repair Kits & Replacement Pump Parts
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-114">
              Keep your systems running with replacement parts and rebuild kits
              for the pumps we carry.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-5" data-id="element-115">
              {partsList.map(part => <div key={part} className="flex items-center gap-2.5" data-id="element-116">
                  <CheckCircle2 className="w-4 h-4 text-marine-cyan flex-shrink-0" data-id="element-117" />
                  <span className="text-sm text-slate-700 font-medium" data-id="element-118">
                    {part}
                  </span>
                </div>)}
            </div>

            <div className="bg-marine-light/60 border border-marine-blue/20 rounded-lg p-4 flex items-start gap-3" data-id="element-119">
              <Info className="w-5 h-5 text-marine-blue flex-shrink-0 mt-0.5" data-id="element-120" />
              <p className="text-sm text-marine-navy leading-relaxed" data-id="element-121">
                Most kits are put together at the time of order, so quantity on
                hand may display as <strong data-id="element-122">0</strong> — these usually ship the
                same day.
              </p>
            </div>
          </div>

          {/* Kit cards */}
          <div className="space-y-4" data-id="element-123">
            <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm" data-id="element-124">
              <div className="flex items-start gap-4" data-id="element-125">
                <div className="bg-slate-100 p-2.5 rounded-md text-slate-600" data-id="element-126">
                  <Wrench className="w-5 h-5" data-id="element-127" />
                </div>
                <div data-id="element-128">
                  <h3 className="text-lg font-bold text-marine-navy mb-1.5" data-id="element-129">
                    Minor Repair Kits
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-130">
                    Include the impeller and gasket or O-ring for that pump.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white border border-marine-blue/30 rounded-lg p-5 shadow-sm ring-1 ring-marine-blue/5" data-id="element-131">
              <div className="flex items-start gap-4" data-id="element-132">
                <div className="bg-marine-blue p-2.5 rounded-md text-white" data-id="element-133">
                  <Package className="w-5 h-5" data-id="element-134" />
                </div>
                <div data-id="element-135">
                  <h3 className="text-lg font-bold text-marine-navy mb-1.5" data-id="element-136">
                    Major Repair Kits
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed" data-id="element-137">
                    Include every replacement part the pump requires except for
                    the shaft and body of the pump.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}